import Link from "next/link";
import classNames from "classnames";
import { useRouter } from "next/router";
import ChevronDown from "../ui/icons/chevron-down";
import { useState } from "react";
const HeaderMenu = ({ data, className }) => {
  const router = useRouter();
  const [activeSubMenu, setActiveSubMenu] = useState(false);
  const handleMouseEnter = () => {
    setActiveSubMenu(true);
  };

  const handleMouseLeave = () => {
    setActiveSubMenu(false);
  };
  const itemClass = "inline-flex items-center lg:text-base text-sm font-light";
  const subLinkClass = `z-[1000] cursor-pointer w-full border-b border-darkGrey last:border-b-0 text-center flex justify-center transition-all duration-200 ease items-center lg:text-base text-sm py-3 last:pb-0 first:pt-0 text-darkGrey hover:text-darkGrey/50 relative focus:outline-none outline-none text-center`;

  return (
    <div
      className={classNames(
        `headerMenu flex w-fit items-center justify-center gap-12 h-full`,
        className
      )}
    >
      {data?.map((item) => (
        <div
          className={`menuItem group flex items-center cursor-pointer group/menuItem h-full`}
          key={item.id}
        >
          {item.path ? (
            <Link
              href={item.path ?? "#"}
              onMouseEnter={() => handleMouseEnter()}
              onMouseLeave={() => handleMouseLeave()}
              className={`${itemClass}
                  ${
                    router?.pathname === item?.path
                      ? "text-[#FCFCFC]"
                      : router?.pathname === "/media" ||
                        router?.pathname.startsWith("/job-openings") ||
                        router?.pathname === "/contact-us"
                      ? "text-darkGrey"
                      : "text-[#FCFCFC]"
                  }
              `}
            >
              <span className="capitalize">{item.label}</span>
              {/* {(item?.columns || item.subMenu) && (
                <ChevronDown className="transition-all duration-300 ease transform group-hover:-rotate-180" />
              )} */}
            </Link>
          ) : (
            <div
              className={`inline-flex items-center lg:text-base text-sm !font-light,
            ${
              router?.pathname === item?.path
                ? "text-[#FCFCFC]"
                : router?.pathname === "/media" ||
                  router?.pathname.startsWith("/job-openings") ||
                  router?.pathname === "/contact-us"
                ? "text-darkGrey"
                : "text-[#FCFCFC]"
            }
        `}
            >
              <span className="font-light">{item.label}</span>
              {/* {(item?.columns || item.subMenu) && (
                <ChevronDown
                  className={`transition-all duration-300 ease transform group-hover:-rotate-180,
                  ${
                    router?.pathname === item?.path
                      ? "text-[#FCFCFC]"
                      : router?.pathname === "/media" ||
                        router?.pathname.startsWith("/job-openings") ||
                        router?.pathname === "/contact-us"
                      ? "text-darkGrey"
                      : "text-[#FCFCFC]"
                  }
              `}
                />
              )} */}
            </div>
          )}

          {item?.subMenu && Array.isArray(item.subMenu) && (
            <div className="!z-[1000] subMenu shadow-subMenu font-body bg-[#FCFCFC] bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-65 w-[184px] flex flex-col px-4 py-4 items-center h-auto absolute overflow-hidden">
              {item?.subMenu.map((menu, index) => {
                // const menuName = `sidebar-submenu-${dept}-${menuIndex}-${index}`;
                return (
                  <Link
                    href={menu.path}
                    key={"subMenu" + index}
                    scroll={false}
                    className={classNames(subLinkClass, {
                      "font-medium": router?.pathname === menu?.path,
                    })}
                  >
                    {menu.label}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default HeaderMenu;
